import {
  TeamExternalIntegration,
  ResponseBodyEvaluation,
  EndpointResponse
} from 'types/api/status-checks/status-check'
import { IntegrationType } from 'utils/team-external-integrations/team-external-integration-types'
import { ENDPOINT_URLS } from 'utils/third-party'

export const newRelicStatusCheckIntegration: TeamExternalIntegration = {
  name: 'New Relic',
  type: IntegrationType.Newrelic,
  authUrl: `${ENDPOINT_URLS.newrelic}v2/applications.json`,
  isPrivateNetworkIntegration: false,
  headers: [{ key: 'X-Api-Key', value: '', label: 'API Key' }],
  url: ENDPOINT_URLS.newrelic,
  sortIndex: 2
}

export const newRelicRegex = new RegExp(
  '^https:\\/\\/api.newrelic.com\\/v\\d/(alerts_incidents|alerts_violations|applications)(\\/.+\\.json|\\.json)'
)

export const convertToNewRelicUrl = (url: string): string => {
  return newRelicRegex.test(url) ? url : null
}

export const computeNewRelicResponseBodyEvaluationConfiguration = (
  url: string
): ResponseBodyEvaluation => {
  const regExpExecArray = newRelicRegex.exec(url)
  const newRelicEntity = regExpExecArray?.[1]
  const isEntityDetailsRequest = regExpExecArray?.[2].indexOf('/') !== -1

  switch (newRelicEntity) {
    case 'alerts_incidents':
      return {
        predicates: [
          {
            jpQuery: '.incidents.length()',
            type: 'Number',
            comparator: 'EQU',
            rValue: '0'
          }
        ],
        op: 'AND'
      } as ResponseBodyEvaluation
    case 'alerts_violations':
      return {
        predicates: [
          {
            jpQuery: '.violations.length()',
            type: 'Number',
            comparator: 'EQU',
            rValue: '0'
          }
        ],
        op: 'AND'
      } as ResponseBodyEvaluation
  }

  if (isEntityDetailsRequest && newRelicEntity === 'applications') {
    return {
      predicates: [
        {
          jpQuery: '.application.health_status',
          type: 'String',
          comparator: 'EQU',
          rValue: 'green'
        }
      ],
      op: 'AND'
    } as ResponseBodyEvaluation
  }

  return {
    predicates: [],
    op: 'AND'
  } as ResponseBodyEvaluation
}

export function getNewRelicApplicationName(
  testEndpointResponse: EndpointResponse,
  integration: TeamExternalIntegration
): string {
  if (integration.url.includes('applications'))
    return JSON.parse(testEndpointResponse?.responseBody)?.application?.name
}
